module.exports = "/images/calling-card.png";